<template>
  <FormKit
    type="form"
    :value="{
      name: name,
      cpf: cpf,
      email: email,
      mobile_number: mobile_number
    }"
    submit-label="Continuar"
    @submit="confirmData"
  >
    <h2 class="text-xl font-bold mb-1">Insira seus dados</h2>

    <FormKit
      type="text"
      name="name"
      label="Seu nome completo sem abreviações*"
      validation="required"
      v-model="name"
      :validation-messages="{
        required: 'Seu nome é obrigatório',
      }"
    />

    <FormKit
      type="text"
      name="cpf"
      id="cpf"
      label="Insira o seu CPF*"
      maxLength="14"
      validation="required|length:14|cpf"
      v-model="cpf"
      ref="cpfInput"
      @change="(event) => normalizeField(event, normalizeCPF, () => cpfInput.node)"
      :validation-messages="{
        required: 'Seu CPF é obrigatório',
        length: 'Quantidade de caracteres inválida'
      }"
    />

    <FormKit
      type="text"
      name="email"
      label="Seu email*"
      validation="required|email"
      v-model="email"
      :validation-messages="{
        required: 'Seu email é obrigatório',
      }"
    />

    <FormKit
      type="text"
      name="mobile_number"
      label="Seu número de celular*"
      validation="required"
      v-model="mobile_number"
      :validation-messages="{
        required: 'Seu número de celular é obrigatório',
      }"
    />

    <template #submit>
      <FooterButton />
    </template>
  </FormKit>
</template>

<script>
  import FooterButton from '../../components/FooterButton.vue'
  import { useRouter } from 'vue-router'
  import { useStore } from '../../../stores/cadastro.js'
  import { ref, onMounted } from 'vue'
  import { normalizeField } from '@/lib/formkit/formkitUtil';

  export default {
    components: {
      FooterButton
    },
    setup() {
      const router = useRouter()
      const store = useStore()

      const name = ref('')
      const cpf = ref('')
      const email = ref('')
      const mobile_number = ref('')

      const cpfInput = ref(null);

      onMounted(() => {
        const preRegistrationData = store.getRegistrationData
        name.value = preRegistrationData.name
        cpf.value = preRegistrationData.cpf
        email.value = preRegistrationData.email
        mobile_number.value = preRegistrationData.mobile_number
      })

      const confirmData = async (formData) => {
        await store.updatePreRegistrationData(formData)
        if (store.shopeeFlow === 'required') {
          router.push({ name: 'Hub' })
        } else if (store.shopeeFlow !== 'hidden') {
          router.push({ name: 'SelectOperation' })
        } else {
          router.push({ name: 'Password' })
        }
      }

      return {
        name,
        cpf,
        email,
        mobile_number,
        confirmData,
        cpfInput,
      }
    },
    methods: {
      normalizeField,

      normalizeCPF(cpf) {
        return cpf
          .replace(/\D/g, '')
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d)/, '$1-$2');
      },
    }
  }
</script>
